/** Canonical public routes (Romanian paths for SEO). */
export const ROUTES = {
  home: "/",
  services: "/servicii",
  articles: "/articole",
  portfolio: "/portofoliu",
  about: "/despre",
  contact: "/contact",
  privacy: "/politica-confidentialitate",
  terms: "/termeni-si-conditii",
  cookies: "/politica-cookie-uri",
};

export function servicePath(slug) {
  return `${ROUTES.services}/${slug}`;
}

export function articlePath(slug) {
  return `${ROUTES.articles}/${slug}`;
}

/** Legacy English paths → 301 targets (also handled in .htaccess). */
export const LEGACY_PATH_MAP = {
  "/services": ROUTES.services,
  "/portfolio": ROUTES.portfolio,
  "/about": ROUTES.about,
};

export function isServicesPath(pathname) {
  return pathname === ROUTES.services || pathname.startsWith(`${ROUTES.services}/`) || pathname === "/services" || pathname.startsWith("/services/");
}

export function normalizeLegacyPath(pathname) {
  if (pathname === "/services" || pathname.startsWith("/services/")) {
    return pathname.replace(/^\/services/, ROUTES.services);
  }
  return LEGACY_PATH_MAP[pathname] || pathname;
}
